import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { MasterPlanSettings } from "building-types/settings/masterPlanSettings";
import type { OptionChoices } from "./optionChoices";

export enum PresetType {
  PRESETS = "PRESETS",
  PROCURE = "PROCURE",
  HOME_PLAN = "HOME_PLAN",
}

export interface Preset extends DocEntityBase<"PRESET"> {
  readonly id: PrimaryEntityId<"PRESET">;
  readonly optionChoices: OptionChoices;
  readonly type: PresetType;
  readonly masterPlanOrder?: number;
  readonly masterPlanSettings?: Partial<MasterPlanSettings>;
  readonly sheetNumberPrefix?: string;
  readonly includeInTest?: boolean;
  readonly price?: number;
  readonly builderOptionCode?: string;
}
